export const yearsToMonths = ( arr ) => {
	const months = arr[2] ? ( arr[1] * 12 ) + Number( arr[2] ) : arr[1] * 12;

	return months;
};



//////////////////
// WEBPACK FOOTER
// ./app/utils/yearsToMonths.js
// module id = 5ufJ
// module chunks = 11